import { cn } from "../../lib/utils";

interface CustomLoaderProps {
  className?: string;
  size?: "xs" | "sm" | "md" | "lg";
  text?: string;
  fullScreen?: boolean;
}

export const CustomLoader = ({
  className,
  size = "md",
  text,
  fullScreen = false,
}: CustomLoaderProps) => {
  const sizeMap = {
    xs: { wrapper: "w-4 h-4", border: "border-2", inset: "inset-1" },
    sm: { wrapper: "w-6 h-6", border: "border-2", inset: "inset-1" },
    md: { wrapper: "w-12 h-12", border: "border-4", inset: "inset-2" },
    lg: { wrapper: "w-16 h-16", border: "border-4", inset: "inset-2" },
  };

  const currentSize = sizeMap[size];

  const loader = (
    <div
      className={cn(
        "flex flex-col items-center justify-center gap-3",
        className
      )}
    >
      <div className={cn("relative", currentSize.wrapper)}>
        {/* Outer Ring */}
        <div
          className={cn(
            "absolute inset-0 rounded-full border-primary/20",
            currentSize.border
          )}
        />
        {/* Animated Inner Ring */}
        <div
          className={cn(
            "absolute inset-0 animate-spin rounded-full border-primary border-b-transparent border-t-transparent transition-all duration-500",
            currentSize.border
          )}
        />
        {/* Inner core pulse */}
        <div
          className={cn(
            "absolute animate-pulse rounded-full bg-primary/40",
            currentSize.inset
          )}
        />
      </div>
      {text && (
        <p className="animate-pulse text-sm font-medium tracking-wide text-muted-foreground">
          {text}
        </p>
      )}
    </div>
  );

  if (fullScreen) {
    return (
      <div className="flex min-h-[300px] w-full items-center justify-center bg-background/50 p-8 backdrop-blur-sm">
        {loader}
      </div>
    );
  }

  return loader;
};
